export const COOKIE_IS_LOGGED_IN = 'isLoggedIn';
export const RX_TAB_ALERT_BANNER_DISMISSED = 'rx-tab-alert-banner-dismissed';
